import React from 'react';
import electricMeter from "../../../icons/icon/electric-meter.svg"
import infoFilled from "../../../icons/icon/info_filled.svg"
import infoOutlined from "../../../icons/info_outlined.svg"


function BlueBoxComponent({icon, extraClassName, children, nocenter  }) {
     return (
        
        <div className={"blue-box w-100 mw-100 d-flex align-items-center " + extraClassName + (nocenter ? "": " justify-content-center")} >
            <div className="me-3">
                {icon === "info-out"&& <img src={infoOutlined} alt="" role="presentation" /> }
                {icon === "info" && <img src={infoFilled} alt="" role="presentation" /> }
                {icon === undefined  && <img src={electricMeter} alt="" role="presentation" /> }
                {/* <DsyIcon name={icon} color="blue"  size="24px"  />  */}
            </div>
            <div>
                {children}
            </div>
        </div>
        
    );
}

export default BlueBoxComponent;